import CloseIcon from "@material-ui/icons/Close";
import {
  Checkbox,
  IconButton,
  withStyles,
  Divider,
  Button,
  CircularProgress,
} from "@material-ui/core";
import WithDrawer from "../../../Dispatch/Common/Drawer/WithDrawer";
import { compose } from "recompose";
import { formatAddress } from "../../../Dispatch/utils/utils";
import { getRemoveAliasData, isAliasesPartiallySelected } from "../utils";
import React from "react";
import { withSnackbar } from "notistack";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import { postData } from "../../../../../api/componentAPIs";
import styles from "./styles";
class AliasesUpdateForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCustomers: [],
    };
  }

  handleAliasSelection = (event) => {
    let updatedList = [...this.state.selectedCustomers];
    if (event.target.checked) {
      updatedList = [...updatedList, event.target.value];
    } else {
      updatedList = updatedList.filter(
        (customerCode) => customerCode !== event.target.value
      );
    }
    this.setState({
      selectedCustomers: updatedList,
    });
  };

  handleAllAliasSelection = (event) => {
    let selectedCustomers = [];
    if (event.target.checked) {
      selectedCustomers = this.props.duplicateCustomers.map(
        (customer) => customer.duplicateCustomerId
      );
    }
    this.setState({
      selectedCustomers,
    });
  };

  removeAlisases = () => {
    this.setState({
      isLoading: true,
    });
    const { selectedCustomers } = this.state;
    const {
      closeDrawer,
      getMergedCustomers,
      userData,
      enqueueSnackbar,
      duplicateCustomers,
    } = this.props;
    const requestData = {
      terminalId: userData.userProfile.terminal.id,
      deleteMergedCustomer: getRemoveAliasData(
        duplicateCustomers,
        selectedCustomers
      ),
    };
    postData("DeleteMergedCustomers", requestData).then(
      (response) => {
        if (response.status === 204) {
          enqueueSnackbar("Aliases removed successfully", {
            variant: "success",
          });
          this.setState({
            isLoading: false,
          });
          getMergedCustomers();
          closeDrawer();
        } else {
          this.setState({
            isLoading: false,
          });
          enqueueSnackbar("Removing aliases failed", {
            variant: "error",
          });
        }
      },
      (_error) => {
        this.setState({
          isLoading: false,
        });
        enqueueSnackbar("Removing aliases failed", {
          variant: "error",
        });
      }
    );
  };

  render() {
    const { closeDrawer, classes, duplicateCustomers, originalCustomerName } =
      this.props;
    const { selectedCustomers, isLoading } = this.state;
    const totalAliasesSelected = this.state.selectedCustomers.length;
    return (
      <>
        <div id="header" className={classes.header}>
          <div className={classes.headerLabelContainer}>
            <Checkbox
              color="primary"
              onChange={this.handleAllAliasSelection}
              indeterminate={isAliasesPartiallySelected(
                totalAliasesSelected,
                duplicateCustomers.length
              )}
              checked={totalAliasesSelected === duplicateCustomers.length}
              className={classes.icon}
            />
            <div className={classes.headerText}>
              <span>{originalCustomerName}</span>
              <span> Aliases</span>
            </div>
          </div>
          <IconButton onClick={closeDrawer}>
            <CloseIcon className={classes.icon} />
          </IconButton>
        </div>
        <div id="content" className={`${classes.content} customScroll`}>
          {duplicateCustomers.map((customer) => (
            <div key={customer.duplicateCustomerId}>
              <div className={classes.checkBoxContainer}>
                <Checkbox
                  color="primary"
                  checked={selectedCustomers.includes(
                    customer.duplicateCustomerId
                  )}
                  onChange={this.handleAliasSelection}
                  className={classes.icon}
                  value={customer.duplicateCustomerId}
                />
                <div className={classes.checkBoxLabelContainer}>
                  <span className={classes.title}>
                    {customer.duplicateCustomerName}
                  </span>
                  <span className={classes.subTitle}>
                    {formatAddress({
                      address: customer.duplicateCustomerAddress,
                      city: customer.duplicateCustomerCity,
                      state: customer.duplicateCustomerState,
                      zip: customer.duplicateCustomerZip,
                    })}
                  </span>
                  <div className={classes.subTitle}>
                    <span className={classes.accountLabel}>Account #:</span>
                    <span>
                      {customer.isMiscCustomer
                        ? ""
                        : ` ${customer.duplicateCustomerCode}`}
                    </span>
                  </div>
                </div>
              </div>
              <Divider className={classes.divider} />
            </div>
          ))}
        </div>
        <div id="action" className={classes.actionContainer}>
          <Button variant="outlined" color="primary" onClick={closeDrawer}>
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={totalAliasesSelected === 0}
            onClick={this.removeAlisases}
            classes={{
              root: classes.redButton,
              disabled: classes.disabledButton,
            }}
          >
            {isLoading ? (
              <CircularProgress
                size={24}
                classes={{ root: classes.circularProgress }}
              />
            ) : (
              "Remove Aliases"
            )}
          </Button>
        </div>
      </>
    );
  }
}

export default compose(
  WithDrawer,
  withSnackbar,
  withUserProfile,
  withStyles(styles)
)(AliasesUpdateForm);
